import React from "react"
import styles from "./transaction-amount.module.scss"
import {Amount} from "../../../../components-shared/formatted-number/formatted-number"

export interface TransactionAmountProps {
  amount: number
  secondary?: boolean
}

export const TransactionAmount : React.FC<TransactionAmountProps> = ({amount}) => {
  return <span className={amount <= 0 ? "" : styles.PositiveAmount}>
    <Amount amount={amount} />
  </span>
}

export const TransactionAmountAlignedRight : React.FC<TransactionAmountProps> = ({amount, secondary}) => {
  const floatRightClassName = amount <= 0 ? styles.AmountFloatRight : styles.PositiveAmountFloatRight
  const classNames = secondary ? `${floatRightClassName} ${styles.Secondary}` : floatRightClassName
  return <span className={classNames}>
    <Amount amount={amount} />
  </span>
}

export interface TransactionImpactProps {
  impact: number
  secondary?: boolean
}

export const TransactionImpactAlignedRight : React.FC<TransactionImpactProps> = ({impact, secondary}) => {
  const classNames = secondary ? `${styles.AmountFloatRight} ${styles.Secondary}` : styles.AmountFloatRight
  return <span className={classNames}>
    {impact} kg
  </span>
}

export interface TransactionImpactProps {
  impact: number
  decimals?: number
}

export const TransactionImpact : React.FC<TransactionImpactProps> = ({impact, decimals = 2}) => {
  const formatter = new Intl.NumberFormat("nl-NL", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
  const displayImpact = formatter.format(impact)

  return <span>
    {displayImpact} kg
  </span>
}

export const formatAmount = (amount: number, decimals: number = 2) => {
  const formatter = new Intl.NumberFormat("nl-NL", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
  const displayAmount = formatter.format(amount)

  return `€ ${displayAmount}`
}

export const formatImpact = (impact: number, decimals: number = 2) => {
  const formatter = new Intl.NumberFormat("nl-NL", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  })
  const displayAmount = formatter.format(impact)

  return `${displayAmount} kg`
}
